import React, { useCallback, useEffect, useLayoutEffect, useRef } from 'react';
import { InteractionManager, StyleSheet, ScrollView, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { AppView } from 'design-system/AppView';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getCategories } from 'actions/user';
import Selector from 'design-system/Selector';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { SCREEN_BOTTOM_PADDING, rem } from 'design-system';
import checkFeatureFlag from 'utils/featureFlags';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import ManageCategoriesList from '../components/categories/ManageCategoriesList';
import { isWeb } from '../../../constants';
import ManageSubcategoriesList from '../components/categories/ManageSubcategoriesList';
const ManageCategoriesScreen = withAnimatedNavigationHeader(({ scrollHandler, navigation, route }) => {
    const showSubcategoriesCreateFlow = useAppSelector((store) => checkFeatureFlag(store.utils.featureFlags, 'show_subcategories_create_flow'));
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => (<HelpScreenButton articlesKey={HELP_ARTICLES_KEY.CUSTOM_CATEGORIES}/>),
        });
    }, []);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!route.params?.skipRefresh) {
            InteractionManager.runAfterInteractions(() => {
                dispatch(getCategories());
            });
        }
    }, [route.params?.skipRefresh]);
    const { paddingHorizontalStyle, contentWidth } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, styles.contentContainer);
    const scrollView = useRef(null);
    const hasScrolled = useRef(false);
    const scrollToSelectedPage = useCallback((selectedPage) => {
        setTimeout(() => {
            scrollView.current?.scrollTo({
                x: selectedPage * contentWidth,
                animated: hasScrolled.current,
            });
            hasScrolled.current = true;
        });
    }, [contentWidth]);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} contentContainerStyle={contentContainerStyle}>
          {showSubcategoriesCreateFlow ? (<View style={[paddingHorizontalStyle, { marginHorizontal: rem(16) }]}>
              <Selector Text-14 sections={['Main categories', 'Subcategories']} onSelected={scrollToSelectedPage} defaultIndex={route.params?.initialTab === 'subcategories' ? 1 : 0}/>
            </View>) : null}

          <ScrollView horizontal ref={scrollView} scrollEnabled={false} showsHorizontalScrollIndicator={false}>
            <View style={[paddingHorizontalStyle, { width: contentWidth }]}>
              <ManageCategoriesList />
            </View>
            <View style={[paddingHorizontalStyle, { width: contentWidth }]}>
              <ManageSubcategoriesList />
            </View>
          </ScrollView>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: 'Manage',
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    contentContainer: {
        marginTop: rem(8),
    },
});
export default ManageCategoriesScreen;
